import type { TooltipProps } from '@mui/material'
import { Tooltip } from '@mui/material'

const STYLED_TOOLTIP_SLOT_PROPS: TooltipProps['slotProps'] = {
  tooltip: {
    sx: {
      backgroundColor: '#464A54',
      color: '#FFFFFF',
      fontWeight: 500,
      fontSize: '12px',
      maxWidth: '180px',
      borderRadius: '8px',
    },
  },
  arrow: {
    sx: {
      color: '#464A54',
    },
  },
}

export const StyledTooltip = ({ arrow = true, placement = 'bottom', ...props }: TooltipProps) => {
  return (
    <Tooltip arrow={arrow} placement={placement} {...props} slotProps={STYLED_TOOLTIP_SLOT_PROPS} />
  )
}
